module.exports = __webpack_public_path__ + "img/mind-mapping.c1127515.png";